import {
  autoplayEnabled,
  blackoutEnabled,
  carouselV2Enabled,
  ccpaOptOutEnabled,
  countdownBannerEnabled,
  currentPosterHoverEnabled,
  emailCaptureEnabled,
  immersiveShowcaseEnabled,
  isEpgSearchEnabled,
  isEpgv2Enabled,
  isFNCv2Enabled,
  isMVPDSSOEnabled,
  isRedirectDisabled,
  liveTileCollectionV2Enabled,
  marineAPIKeyEnabled,
  mobileWebRoadblockEnabled,
  mvpdDeeplinkEnabled,
  nationDigitalChannelEnabled,
  nationUngatedCTAEnabled,
  previewModeEnabled,
  previewPass60MinDisabled,
  previewPassEnabled,
  secondScreenProfileEnabled,
  seriesAnonymousEnabled,
  seriesV2Enabled,
  simplifiedPosterHoverEnabled,
  strikeBannerEnabled,
  upNextLiveEventsEnabled,
  watchV2Enabled,
} from 'helpers/ConfigHelper';
import {
  DEBUG_PANEL_EMAIL_CAPTURE,
  DEBUG_PANEL_FLAG_ADDITIONAL_POSTER_CURRENT_HOVER,
  DEBUG_PANEL_FLAG_ADDITIONAL_POSTER_SIMPLIFIED_HOVER,
  DEBUG_PANEL_FLAG_BLACKOUT,
  DEBUG_PANEL_FLAG_CAROUSEL_V2,
  DEBUG_PANEL_FLAG_CCPA_OPT_OUT,
  DEBUG_PANEL_FLAG_COUNTDOWN_BANNER,
  DEBUG_PANEL_FLAG_DISABLE_REDIRECT,
  DEBUG_PANEL_FLAG_EPG_SEARCH,
  DEBUG_PANEL_FLAG_EPGV2,
  DEBUG_PANEL_FLAG_FNCV2,
  DEBUG_PANEL_FLAG_GLOBAL_PLAYER_AUTOPLAY,
  DEBUG_PANEL_FLAG_IMMERSIVE_SHOWCASE,
  DEBUG_PANEL_FLAG_MOBILE_WEB_ROADBLOCK,
  DEBUG_PANEL_FLAG_MVPD_DEEPLINK,
  DEBUG_PANEL_FLAG_MVPD_SSO,
  DEBUG_PANEL_FLAG_NATION_DIGITAL_CHANNEL,
  DEBUG_PANEL_FLAG_NATION_UNGATED_CTA,
  DEBUG_PANEL_FLAG_PREVIEW_MODE,
  DEBUG_PANEL_FLAG_PREVIEW_PASS_60_MIN,
  DEBUG_PANEL_FLAG_PREVIEW_PASS,
  DEBUG_PANEL_FLAG_SECOND_SCREEN_PROFILE,
  DEBUG_PANEL_FLAG_SERIES_ANONYMOUS,
  DEBUG_PANEL_FLAG_SERIES_V2,
  DEBUG_PANEL_FLAG_STRIKE_BANNER,
  DEBUG_PANEL_FLAG_TILE_LIVE_TILE_V2,
  DEBUG_PANEL_FLAG_UPNEXT_LIVE_EVENTS,
  DEBUG_PANEL_FLAG_USE_MARINE_API_KEY,
  DEBUG_PANEL_FLAG_WATCH_V2,
} from 'helpers/ContentHelper';

const FlagMap = [
  {
    name: 'Blackout',
    nickname: 'BO',
    description: 'Simulates a blackout for an MVPD dropping support for fox',
    dateAdded: '2021, 5, 3',
    jiraTicketNumber: 'CPEWEB-3240',
    checked: blackoutEnabled(),
    flagName: DEBUG_PANEL_FLAG_BLACKOUT,
    permanent: false,
    brand: 'both',
  },
  {
    name: 'Preview Pass',
    nickname: 'PP',
    description: 'Controls wether the site will utilize Preview Pass for Gated Content',
    dateAdded: '2021, 5, 3',
    jiraTicketNumber: 'CPEWEB-3240',
    checked: previewPassEnabled(),
    flagName: DEBUG_PANEL_FLAG_PREVIEW_PASS,
    permanent: true,
    brand: 'both',
  },
  {
    name: 'Preview Pass: 60 Min Disable',
    nickname: 'PP5M',
    description:
      'Disables 60 minute preview pass so 5 minute preview pass can be utilized for shorter testing',
    dateAdded: '2021, 3, 4',
    jiraTicketNumber: 'CPEWEB-2908',
    checked: previewPass60MinDisabled(),
    flagName: DEBUG_PANEL_FLAG_PREVIEW_PASS_60_MIN,
    permanent: true,
    brand: 'both',
  },
  {
    name: 'MVPD Deeplink',
    nickname: 'MVPD',
    description: 'Creates a Deep Link URL that can be linked to by marketing for MVPD Login',
    dateAdded: '2019, 1, 30',
    jiraTicketNumber: 'DCGWEB-5514',
    checked: mvpdDeeplinkEnabled(),
    flagName: DEBUG_PANEL_FLAG_MVPD_DEEPLINK,
    permanent: false,
    brand: 'fox',
  },
  {
    name: 'Autoplay',
    nickname: 'AP',
    description: 'Toggles the autoplay feature on Global Video Player',
    dateAdded: '2021, 5, 3',
    jiraTicketNumber: 'CPEWEB-3240',
    checked: autoplayEnabled(),
    flagName: DEBUG_PANEL_FLAG_GLOBAL_PLAYER_AUTOPLAY,
    permanent: true,
    brand: 'both',
  },
  {
    name: 'Use Marine API Key',
    nickname: 'MAP',
    description:
      'Allows API calls to be routed using the Marine API Key instead of the Environments Key',
    dateAdded: '2021, 5, 3',
    jiraTicketNumber: 'CPEWEB-3240',
    checked: marineAPIKeyEnabled(),
    flagName: DEBUG_PANEL_FLAG_USE_MARINE_API_KEY,
    permanent: true,
    brand: 'both',
  },
  {
    name: 'Preview Mode',
    nickname: 'PM',
    description:
      'As a DPP user (content programmer), i want to be able to publish content in a "preview" state and see what it looks like in client applications before i publish the content to be "live".',
    dateAdded: '2019, 7, 24',
    jiraTicketNumber: 'DCGWEB-6929',
    checked: previewModeEnabled(),
    flagName: DEBUG_PANEL_FLAG_PREVIEW_MODE,
    permanent: true,
    brand: 'both',
  },
  {
    name: 'Disable Redirect',
    nickname: 'DR',
    description:
      'Disables the redirect to login for users that are changing environments when an API encounters a 401 error. This is necessary to enable when changing to INT',
    dateAdded: '2023, 6, 1',
    jiraTicketNumber: 'NATWEB-1422',
    checked: isRedirectDisabled(),
    flagName: DEBUG_PANEL_FLAG_DISABLE_REDIRECT,
    permanent: true,
    brand: 'both',
  },
  {
    name: 'Series Detail Anonymous',
    nickname: 'SDA',
    description:
      'Series Pages to drive subscription conversion for Nation by providing a more engaging content experience around the selected Show/Personality.',
    dateAdded: '2021, 5, 3',
    jiraTicketNumber: 'CPEWEB-183',
    checked: seriesAnonymousEnabled(),
    flagName: DEBUG_PANEL_FLAG_SERIES_ANONYMOUS,
    permanent: false,
    brand: 'nation',
  },
  {
    name: 'Series Detail V2',
    nickname: 'SDV2',
    description: 'Create a more meaningful Series destination for users',
    dateAdded: '2020, 4, 30',
    jiraTicketNumber: 'CPEWEB-1083',
    checked: seriesV2Enabled(),
    flagName: DEBUG_PANEL_FLAG_SERIES_V2,
    permanent: false,
    brand: 'fox',
  },
  {
    name: 'FNC v2',
    nickname: 'FNC2',
    description:
      'The Fox Nation Digital Channel project involves bringing multiple live channel options to the user.  This is basically an expansion of the FoxNews live feature.',
    dateAdded: '2020, 4, 6',
    jiraTicketNumber: 'CPEWEB-884',
    checked: isFNCv2Enabled(),
    flagName: DEBUG_PANEL_FLAG_FNCV2,
    permanent: false,
    brand: 'nation',
  },
  {
    name: 'EPG v2',
    nickname: 'EPG2',
    description: 'Redesign for the Electronic Programming Guide (EPG) for Fox.com.',
    dateAdded: '2021, 1, 8',
    jiraTicketNumber: 'CPEWEB-2399',
    checked: isEpgv2Enabled(),
    flagName: DEBUG_PANEL_FLAG_EPGV2,
    permanent: false,
    brand: 'fox',
  },
  {
    name: 'EPG Search Enabled',
    nickname: 'EPGS',
    description: 'Enables Search Functionality for EPG Listings',
    dateAdded: '2021, 1, 8',
    jiraTicketNumber: 'CPEWEB-2399',
    checked: isEpgSearchEnabled(),
    flagName: DEBUG_PANEL_FLAG_EPG_SEARCH,
    permanent: false,
    brand: 'fox',
  },
  {
    name: 'Live Tile V2',
    nickname: 'LTV2',
    description: 'Enables new designs on Live Tiles with the circle station icons',
    dateAdded: '2020, 2, 5',
    jiraTicketNumber: 'CPEWEB-750',
    checked: liveTileCollectionV2Enabled(),
    flagName: DEBUG_PANEL_FLAG_TILE_LIVE_TILE_V2,
    permanent: false,
    brand: 'fox',
  },
  {
    name: 'Nation Digital Channel',
    nickname: 'NGC',
    description:
      'The Fox Nation Digital Channel project involves bringing multiple live channel options to the user.  This is basically an expansion of the FoxNews live feature.',
    dateAdded: '2020, 4, 6',
    jiraTicketNumber: 'CPEWEB-884',
    checked: nationDigitalChannelEnabled(),
    flagName: DEBUG_PANEL_FLAG_NATION_DIGITAL_CHANNEL,
    permanent: false,
    brand: 'nation',
  },
  {
    name: 'Nation Ungated CTA',
    nickname: 'NUCT',
    description: 'Add an indicator when a user is authenticated/unauthathenticated',
    dateAdded: '2020, 7, 7',
    jiraTicketNumber: 'CPEWEB-1680',
    checked: nationUngatedCTAEnabled(),
    flagName: DEBUG_PANEL_FLAG_NATION_UNGATED_CTA,
    permanent: false,
    brand: 'nation',
  },
  {
    name: 'Additional Poster Current Hover',
    nickname: 'APCH',
    description:
      'Nation stakeholders want the ability to display more content per page/fold on Web. To accomplish that, the main requirement is to reduce Poster size and include additional item.',
    dateAdded: '2020, 4, 17',
    jiraTicketNumber: 'CPEWEB-1090',
    checked: currentPosterHoverEnabled(),
    flagName: DEBUG_PANEL_FLAG_ADDITIONAL_POSTER_CURRENT_HOVER,
    permanent: false,
    brand: 'nation',
  },
  {
    name: 'Additional Poster Simplified Hover',
    nickname: 'APSH',
    description:
      'Nation stakeholders want the ability to display more content per page/fold on Web. To accomplish that, the main requirement is to reduce Poster size and include additional item.',
    dateAdded: '2020, 4, 17',
    jiraTicketNumber: 'CPEWEB-1090',
    checked: simplifiedPosterHoverEnabled(),
    flagName: DEBUG_PANEL_FLAG_ADDITIONAL_POSTER_SIMPLIFIED_HOVER,
    permanent: false,
    brand: 'nation',
  },
  {
    name: 'CCPA Opt Out Toggle',
    nickname: 'CCPA',
    description: 'Enables the CCPA Opt out page',
    dateAdded: '2020, 4, 13',
    jiraTicketNumber: 'CPEWEB-1013',
    checked: ccpaOptOutEnabled(),
    flagName: DEBUG_PANEL_FLAG_CCPA_OPT_OUT,
    permanent: false,
    brand: 'both',
  },
  {
    name: 'Second Screen Profile',
    nickname: 'SSP',
    description:
      'Enable a way for a user logging into a Connected TV Device to log in using the website',
    dateAdded: '2020, 5, 26',
    jiraTicketNumber: 'CPEWEB-1220',
    checked: secondScreenProfileEnabled(),
    flagName: DEBUG_PANEL_FLAG_SECOND_SCREEN_PROFILE,
    permanent: false,
    brand: 'both',
  },
  {
    name: 'Strike Banner',
    nickname: 'SB',
    description: 'Displays Ads on Web using Strike Platform',
    dateAdded: '2020, 6, 18',
    jiraTicketNumber: 'CPEWEB-1591',
    checked: strikeBannerEnabled(),
    flagName: DEBUG_PANEL_FLAG_STRIKE_BANNER,
    permanent: true,
    brand: 'fox',
  },
  {
    name: 'Countdown Banner',
    nickname: 'CB',
    description: 'Displays the CPAC Countdown Banner for the showcase and mid collections',
    dateAdded: '2021, 10, 21',
    jiraTicketNumber: 'CPEWEB-4038',
    checked: countdownBannerEnabled(),
    flagName: DEBUG_PANEL_FLAG_COUNTDOWN_BANNER,
  },
  {
    name: 'MVPD SSO',
    nickname: 'MSSO',
    description: 'Links MVPD to Logged in User',
    dateAdded: '2021, 10, 13',
    jiraTicketNumber: 'CPEWEB-3620',
    checked: isMVPDSSOEnabled(),
    flagName: DEBUG_PANEL_FLAG_MVPD_SSO,
    permanent: false,
    brand: 'nation',
  },
  {
    name: 'Email Capture',
    nickname: 'EC',
    description: 'Enabled Email Capture on Ungated Content',
    dateAdded: '2022, 06, 15',
    jiraTicketNumber: 'NATWEB-462',
    checked: emailCaptureEnabled(),
    flagName: DEBUG_PANEL_EMAIL_CAPTURE,
    permanent: false,
    brand: 'nation',
  },
  {
    name: 'Carousel V2',
    nickname: 'CARV2',
    description: 'Converted React-Slick to Pure-React-Carousel',
    dateAdded: '2022, 08, 19',
    jiraTicketNumber: 'NATWEB-594',
    checked: carouselV2Enabled(),
    flagName: DEBUG_PANEL_FLAG_CAROUSEL_V2,
    permanent: false,
    brand: 'nation',
  },
  {
    name: 'Immersive Showcase',
    nickname: 'IMSHO',
    description: 'Immersive Showcase for marketing',
    dateAdded: '2022, 08, 28',
    jiraTicketNumber: 'NATWEB-595',
    checked: immersiveShowcaseEnabled(),
    flagName: DEBUG_PANEL_FLAG_IMMERSIVE_SHOWCASE,
    permanent: false,
    brand: 'nation',
  },
  {
    name: 'Mobile Web Roadblock',
    nickname: 'MWR',
    description: 'Mobile Web Roadblock',
    dateAdded: '2023, 5, 17',
    jiraTicketNumber: 'NATWEB-1321',
    checked: mobileWebRoadblockEnabled(),
    flagName: DEBUG_PANEL_FLAG_MOBILE_WEB_ROADBLOCK,
    permanent: false,
    brand: 'nation',
  },
  {
    name: 'Watch V2',
    nickname: 'WV2',
    description: 'Watch V2',
    dateAdded: '2023, 7, 20',
    jiraTicketNumber: 'ARTNATION-460',
    checked: watchV2Enabled(),
    flagName: DEBUG_PANEL_FLAG_WATCH_V2,
    permanent: false,
    brand: 'nation',
  },
  {
    name: 'Upnext Live Events',
    nickname: 'ULE',
    description: 'Up Next for Live Events',
    dateAdded: '2023, 10, 26',
    jiraTicketNumber: 'NATWEB-1585',
    checked: upNextLiveEventsEnabled(),
    flagName: DEBUG_PANEL_FLAG_UPNEXT_LIVE_EVENTS,
    permanent: false,
    brand: 'nation',
  },
];

export default FlagMap;
